<template>
	<div>
		<header>
			<h1>Commissions</h1>
		</header>
		<div>
			<loader v-if="!loaded"/>
			<template v-if="loaded">
				<div class="sections sections--flexed">
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span v-if="!$can('invoice.create')" class="metrics__metric__stats__title">Owed </span>
							<span
								v-if="$can('invoice.create')" class="metrics__metric__stats__title">Invoiceable </span>
							<span
								class="metrics__metric__stats__value --large" data-metric-number
								v-html="$present('price', stats.owed)"></span>
						</p>
					</section>
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Paid </span>
							<span
								class="metrics__metric__stats__value --large" data-metric-number
								v-html="$present('price', stats.paid)"></span>
						</p>
					</section>
				</div>
				<div class="section">
					<table-filter :filters="filters"/>
					<div class="filtered-options">
						<process-button
							v-if="$can('invoice.create') && stats.readyToBeAddedToInvoice"
							:processing="raisingInvoice"
							class="button button--primary" text="Raise Invoice" @click="raiseInvoice"/>
					</div>
					<div v-if="!items.length" class="nothing-to-see-here">
						<p>Nothing to display.</p>
					</div>
					<v-table v-if="items.length" :loading="gettingModels">
						<thead>
							<tr>
								<th align="left">Client</th>
								<th align="left">Service</th>
								<th align="left">Value</th>
								<th align="center">Status</th>
							</tr>
						</thead>
						<tfoot>
							<tr>
								<th align="left">Client</th>
								<th align="left">Service</th>
								<th align="left">Value</th>
								<th align="center">Status</th>
							</tr>
						</tfoot>
						<tbody>
							<tr v-for="(item, index) in items">
								<td v-if="!$can('view', item.cause)" v-html="$present('fullName', item.cause.client)"/>
								<td v-html="$enum('ServiceTypes').display(item.cause.service)"/>
								<td v-if="$can('view', item.cause)">
									<router-link
										:to="{name: 'instructions.show', params: {instruction: item.cause.id}}"
										v-html="$present('fullName', item.cause.client)"/>
								</td>
								<td v-if="!item.value">—</td>
								<td v-if="item.value" v-html="$present('price', item.value)"/>
								<td align="center">
									<status-badge :status="item.status" group="commission"/>
								</td>
							</tr>
						</tbody>
					</v-table>
					<paginator :links="links" :meta="meta"/>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapState, mapActions} = createNamespacedHelpers("commissions");

export default {

	data() {
		return {
			raisingInvoice: false,
		};
	},

	computed: {
		...mapState([
			"columns",
			"items",
			"links",
			"loaded",
			"gettingModels",
			"meta",
			"stats",
			"query",
			"filters",
		]),
	},

	methods: {
		...mapActions([
			"getModels",
			"goToPage",
			"paginate",
			"filter",
		]),
		raiseInvoice() {
			this.raisingInvoice = !this.raisingInvoice;
			http().post("commissions/invoice", {
				params: this.query,
			}).then(response => {
				this.raisingInvoice = !this.raisingInvoice;
			}).catch(error => {
				this.raisingInvoice = !this.raisingInvoice;
			});
		},
	},

	created() {
		this.getModels();
	},
};
</script>
